<template>
  <div>
    <div slot="toolbar" style="display: flex; flex-direction: row; justify-content: space-between">
      <el-button v-if="addAuth" type="primary" style="margin-bottom: 10px" @click="$refs.editSystemNavItemNew.open(0)"> 新建 </el-button>
      <div style="display: flex; flex-direction: row; height: 28px">
        <el-input v-model="inputFilter" style="height: 100%" placeholder="请输入内容" clearable/>
        <div class="ad-search-btn">
          <el-button
              type="primary"
              size="mini"
              style="height: 100%; padding: 0 10px"
              @keyup.enter.native="handleSearchClick"
              @click="handleSearchClick">
            查询
          </el-button>
        </div>
      </div>
    </div>
    <el-table
        border
        :data="tableData"
        style="width: 100%"
        row-key="id"
        :tree-props="{ children: 'children', hasChildren: 'hasChildren' }">
      <el-table-column width="180px" label="名称" prop="other.title"/>
      <el-table-column label="ID" align="center" width="80" prop="other.id"/>
      <el-table-column
          label="HREF"
          show-overflow-tooltip
          align="center"
          width="80"
          prop="other.href"/>
      <el-table-column label="菜单类型" width="120" align="center" prop="other.category">
        <template slot-scope="scope">
          <span>{{categorys[scope.row.other.category]}}</span>
        </template>
      </el-table-column>
      <el-table-column label="图标" width="160" prop="other.image"/>
      <el-table-column label="级别" align="center" width="80" prop="other.level"/>
      <el-table-column label="SeqNO" width="80" align="center" prop="other.seqNO"/>
      <el-table-column label="功能" prop="other.functionName"/>
      <el-table-column label="操作" align="center" width="120px">
        <template slot-scope="scope">
          <el-button v-if="editAuth" type="primary" @click="$refs.editSystemNavItem.open(scope.row.id)"> 编辑 </el-button>
          <el-button v-if="delAuth" type="danger" @click="deleteRow(scope.row)"> 删除 </el-button>
        </template>
      </el-table-column>
    </el-table>
    <system-nav-item-edit ref="editSystemNavItem" @save-success="getList(1)"/>
    <system-nav-item-create ref="editSystemNavItemNew" @save-success="getList(1)"/>
  </div>
</template>

<script>
  import constant from "../../../util/constant";
  import SystemNavItemEdit from "@/views/SystemInfo/systemNavItem/SystemNavItemEdit";
  import SystemNavItemCreate from "@/views/SystemInfo/systemNavItem/SystemNavItemCreate";
  export default {
    name: "SystemNavItem",
    components: { SystemNavItemCreate, SystemNavItemEdit },
    data() {
      return {
        addAuth: this.$auth(47),
        editAuth: this.$auth(48),
        delAuth: this.$auth(49),
        constant,
        categorys: constant.category,
        tableData: [],
        inputFilter: "",
        filter: {
          filter: "",
        },
      };
    },
    mounted() {
      this.getList();
    },
    methods: {
      getList() {
        this.$http.get("basic", "navItems/tree", this.filter).then((resp) => {
          if (resp.success) {
            this.tableData = resp.data;
          }
        });
      },

      handleSearchClick() {
        this.filter.filter = this.inputFilter;
        this.getList();
      },

      deleteRow(row) {
        this.$confirm("确定删除吗?", "提示", { type: "warning" }).then(() => {
          this.$http.delete("basic", "navItems", row.id).then((resp) => {
            if (resp.success) {
              this.getList();
              this.$message.success("删除成功");
              this.idList = "";
            }
          });
        });
      },
    },
  };
</script>

<style scoped></style>
